export default __webpack_public_path__ + "static/aws-partner-logo-46151580066e3ed1166618fbf99a7fd5.png";